<template>
  <card>

  </card>
</template>
<script>

export default {
  name: "quit",
  created() {
    this.$http.defaults.headers.common["Authorization"] = null;
    localStorage.removeItem('token');
    this.$store.dispatch("setUser", null);
    this.$router.push('/dashboard');
  },
};
</script>
<style>
</style>
